import {
  PromoBanner,
  RewardsBanner,
  LoyaltyInterruptModal,
  LargeOrderPromo,
  LargeOrderPromoCard,
  JoinRewards,
  LegalCopy,
  UpsellItem,
  GuacMode,
  SystemFlags,
  FeaturedPCE,
  OrderWebMetadata,
  OrderWebTitleDescription,
  PickupModality,
  CreateAccountSignInContentFragment,
  OrderConfirmationCreateAccountExperience,
  FacModalContent,
  NutritionFactsContentFragment,
  AccountModalContentFragment,
  TaxContent,
  BagContent,
  AccountOptInToolTipsContentFragment,
  OrderReviewModalContentFragment,
  ScanlessIntroductionContentFragment,
  CyobRewardContentFragment,
  ReferAFriendFooterContentFragment,
  ReferAFriendModalContentFragment,
  ReferralJoinSuccessContentFragment,
  ReferralNotEligibleContentFragment,
  AlreadyAMemberModalContentFragment,
  YoureInvitedModalContentFragment,
  ReferAFriendLinkOpenedContentFragment,
  SummerOfExtrasIntroScreensContentFragment,
  ScanlessCreditCardAlreadyAssociatedContentFragment,
  ChipotleuReVerificationContentFragment,
  ChipotleuReVerificationSuccessModalContentFragment,
  EmployeeRewardsHowItWorksModalContentFragment
} from '@/models/cms';
import { CmsLink } from '@/models/cms';
import {
  getPromoBanner,
  getHeaderLinks,
  getRewardsBanner,
  getLargeOrderPromo,
  getLargeOrderCard,
  getSystemFlags,
  getGuacMode,
  getFeaturedPCE,
  getMetadata,
  getOrderWebTitleAndDescription,
  getNutritionPath,
  getOrderConfirmationGuest,
} from './builders';
import { LogLevel } from '@/services/logger/logger';
import { getCountryCodeByTopLevelDomain } from '@/helpers';
import { CountryCode } from '@/store/ui';
import axios from 'axios'
import CmgYoureInvitedModal from '@/components/referral/CmgYoureInvitedModal/cmg-youre-invited-modal';

export interface Config {
  isLocal: boolean;
  recaptcha: {
    key: string;
    accountName: string;
  };

  payeezy: {
    jsHost: string;
    apiKey: string;
    jsSecurityKey: string;
    taToken: string;
    jsLibrary: string;
  };

  chase: {
    baseFormUrl: string;
    jsLibraryUrl: string;
  };

  chaseuk: {
    baseFormUrl: string;
    redirectUrl: string;
  };

  ucom: {
    jsLibraryUrl: string;
    isDebugConfiguration: boolean;
  };

  seon: {
    jsCdnHost: string;
  }

  pepper: {
    jsLibraryUrl: string;
    cssLibraryUrl: string;
  }

  applePay: {
    merchantIdUcom: string;
    merchantIdChaseCanada: string;
  }

  googlePay: {
    merchantGateway: string;
    merchantGatewayIdUcom: string;
    merchantGatewayCanada: string;
    merchantGatewayIdChaseCanada: string;
    merchantId: string;
    environment: string;
  }

  idMe: {
    clientId: string;
    redirectUrl: string;
    widgetScriptUrl: string;
  }

  services: {
    gatewayUrl: string;
    gatewaySubscriptionKey: string;
    gatewayUrlUk: string;
    gatewaySubscriptionKeyUk: string;
    channel: string;
    refreshPointsThrottleTimeInMinutes?: number;
  };

  cms: {
    baseUrl: string;
    baseUrlCanada: string;
    baseUrlUk: string;
    headerLinks: CmsLink[];
    promoBannerTopGuestDesktop: PromoBanner | null;
    promoBannerTopGuestMobile: PromoBanner | null;
    promoBannerTopAuthenticatedDesktop: PromoBanner | null;
    promoBannerTopAuthenticatedMobile: PromoBanner | null;
    promoBannerTopGuestDesktopCanada: PromoBanner | null;
    promoBannerTopGuestMobileCanada: PromoBanner | null;
    promoBannerTopAuthenticatedDesktopCanada: PromoBanner | null;
    promoBannerTopAuthenticatedMobileCanada: PromoBanner | null;
    promoBannerBottom: PromoBanner | null;
    promoBannerBottomCanada: PromoBanner | null;
    promoBannerRewardsGuest: PromoBanner | null;
    promoBannerRewardsAuthenticatedNotEnrolled: PromoBanner | null;
    largeOrderPromo: LargeOrderPromo | null;
    guacMode: GuacMode | null;
    groupOrderCard: LargeOrderPromoCard | null;
    cateringCard: LargeOrderPromoCard | null;
    cateringCardCanada: LargeOrderPromoCard | null;
    joinRewards?: JoinRewards | null;
    legalCopy?: LegalCopy;
    homePageRewardsBanner: RewardsBanner;
    homePagePromoBannerCanada: RewardsBanner;
    rewardsPageGuacModeRewardsBanner: RewardsBanner;
    rewardsPageGuestUnenrolledRewardsBanner: RewardsBanner;
    loyaltyInterruptModal?: LoyaltyInterruptModal;
    dynamicUpsellItems?: UpsellItem[];
    upsellItems?: UpsellItem[];
    systemFlags: SystemFlags;
    createAccountFormFragment?: CreateAccountSignInContentFragment;
    accountOptInToolTipsFragment?: AccountOptInToolTipsContentFragment;
    accountModalFragment?: AccountModalContentFragment;
    signInModalFragment?: CreateAccountSignInContentFragment;
    nutritionFactsFragment?: NutritionFactsContentFragment;
    orderReviewModal?: OrderReviewModalContentFragment;
    scanlessIntroductionFragment?: ScanlessIntroductionContentFragment;
    scanlessInfoIconFragment?: ScanlessIntroductionContentFragment;
    scanlessCreditCardAlreadyAssociated?: ScanlessCreditCardAlreadyAssociatedContentFragment;
    cyobRewardCard?: CyobRewardContentFragment;
    referAFriendFooter?: ReferAFriendFooterContentFragment;
    referAFriendModal?: ReferAFriendModalContentFragment;
    referralJoinSuccessModal?: ReferralJoinSuccessContentFragment;
    referralNotEligibleModal?: ReferralNotEligibleContentFragment;
    alreadyAMemberModal?: AlreadyAMemberModalContentFragment;
    youreInvitedModal?: YoureInvitedModalContentFragment;
    referAFriendLinkOpened?: ReferAFriendLinkOpenedContentFragment;
    featuredPCE: FeaturedPCE;
    metadata: OrderWebMetadata | null;
    titleAndDescription: OrderWebTitleDescription | null;
    fullNutritionURL: string | undefined;
    pickupModality?: PickupModality;
    orderConfirmationCreateAccountExperience: OrderConfirmationCreateAccountExperience | null;
    facModalContent?: FacModalContent;
    taxContent?: TaxContent;
    bagContent?: BagContent;
    summerOfExtrasIntroScreens?: SummerOfExtrasIntroScreensContentFragment;
    chipotleuReVerification?: ChipotleuReVerificationContentFragment;
    chipotleuReVerificationSuccessModal?: ChipotleuReVerificationSuccessModalContentFragment;
    employeeRewardsHowItWorksModal?: EmployeeRewardsHowItWorksModalContentFragment;
  };

  urls: {
    buyGiftCards: string;
    support: string;
    catering: string;
    rewardsTerms: string;
    faq: string;
    sessionFrameUrl: string;
    realFoodprint: string;
    howGood: string;
    rewardsPath: string;
    offersPath: string;
    twitterAchievementBaseUrl: string;
    allergenStatementUrl: string;
  };

  logging: {
    level: LogLevel;
    shouldVerifyFields: boolean;
    maxFieldsLength?: number;
  };

  google: {
    mapsUrl: string;
    mapsApiKey: string;
    mapsAuth?: string;
    showRestaurantsWithNoAddress: boolean;
  };

  build: string;

  isStubPayment: boolean;
  stubPaymentInformation: {
    cardHolderName: string;
    chipotleWalletId: number | undefined;
    creditCardExpiration: string;
    creditCardSingleUseToken: string;
    creditCardType: string;
    creditCardZipCode: string;
    lastFourAccountNumbers: string;
    paymentProviderId: string;
    paymentProviderId_CA: string;
    paymentType: string;
  }

  optinProgramLaunchDate: string;
  
  split: {
    authorizationKey: string;
  };
}

export enum AEMVariables {
  promoBannerTopAuthenticatedDesktop = '_cmgPromoTopGuestDesktop',
  promoBannerTopAuthenticatedMobile = '_cmgPromoTopGuestMobile',
  promoBannerTopGuestDesktop = '_cmgPromoTopGuestDesktop',
  promoBannerTopGuestMobile = '_cmgPromoTopGuestMobile',
  promoBannerTopAuthenticatedDesktopCanada = '_cmgPromoTopGuestDesktopCanada',
  promoBannerTopAuthenticatedMobileCanada = '_cmgPromoTopGuestMobileCanada',
  promoBannerTopGuestDesktopCanada = '_cmgPromoTopGuestDesktopCanada',
  promoBannerTopGuestMobileCanada = '_cmgPromoTopGuestMobileCanada',
  promoBannerBottom = '_cmgPromoBottom',
  promoBannerBottomCanada = '_cmgPromoBottomCanada',
  promoBannerRewardsGuest = '_cmgPromoRewardsHeroGuest',
  promoBannerRewardsAuthenticatedNotEnrolled = '_cmgPromoRewardsHeroAuthenticatedNotEnrolled',
  largeOrderPromo = '_cmgLargeOrderPromo',
  guacMode = '_cmgGuacMode',
  groupOrderCard = '_cmgGroupOrderCard',
  cateringCard = '_cmgCateringCard',
  cateringCardCanada = '_cmgCateringCardCanada',
  joinRewards = '_cmgJoinRewards',
  legalCopy = '_cmgLegalCopy',
  homePageRewardsBanner = '_cmgHomePageRewardsBanner',
  homePagePromoBannerCanada = '_cmgHomePagePromoBannerCanada',
  rewardsPageGuacModeRewardsBanner = '_cmgRewardsPageGuacModeRewardsBanner',
  rewardsPageGuestUnenrolledRewardsBanner = '_cmgRewardsPageGuestUnenrolledRewardsBanner',
  loyaltyInterruptModal = '_cmgLoyaltyInterruptModal',
  dynamicUpsellItems = '_cmgDynamicUpsell',
  systemFlags = '_cmgSystemFlags',
  featuredPCE = '_cmgFeaturedPCE',
  metadata = '_cmgTitleAndDescription',
  createAccountFormFragment = '_cmgCreateAccountForm',
  signInModalFragment = '_cmgSignInModal',
  titleAndDescription = '_cmgTitleAndDescription',
  fullNutritionURL = '_cmgNutritionPdf',
  fullNutritionURLCanada = '_cmgNutritionPdfCanada',
  pickupModality = '_cmgPickupOptions',
  orderConfirmationCreateAccountExperience = '_cmgOrderConfirmationGuest'
}

export async function buildConfig(): Promise<Config> {
  const isCanada = getCountryCodeByTopLevelDomain() == CountryCode.CA;
  const isUK = getCountryCodeByTopLevelDomain() == CountryCode.GB || getCountryCodeByTopLevelDomain() == CountryCode.UK;
  const cmsBaseUrl = str(process.env.VUE_APP_CMS_BASEURL);
  const cmsBaseUrlCanada = str(process.env.VUE_APP_CMS_BASEURL_CANADA);
  const cmsBaseUrlUk = str(process.env.VUE_APP_CMS_BASEURL_UK);
  const gqlUrl = '/graphql/execute.json/chipotle';
  const isLocal = bool(process.env.VUE_APP_IS_LOCAL);
  const cateringUrl = isCanada ? str(process.env.VUE_APP_URL_CATERING_CANADA) : str(process.env.VUE_APP_URL_CATERING);
  let indexedCmsVars: { [index: string]: Object } = {};
  let region = '';

  if (isCanada) {
    region = 'en-ca'
  } else if (isUK) {
    region = 'en-gb'
  } else {
    region = 'en-us'
  }


  return {
    isLocal,
    recaptcha: {
      key: str(process.env.VUE_APP_RECAPTCHA_KEY),
      accountName: str(process.env.VUE_APP_RECAPTCHA_ACCOUNT_NAME),
    },
    payeezy: {
      jsHost: str(process.env.VUE_APP_PAYEEZY_JS_HOST),
      apiKey: str(process.env.VUE_APP_PAYEEZY_API_KEY),
      jsSecurityKey: str(process.env.VUE_APP_PAYEEZY_JS_SECURITY_KEY),
      taToken: str(process.env.VUE_APP_PAYEEZY_TA_TOKEN),
      jsLibrary: str(process.env.VUE_APP_PAYEEZY_JS_LIBRARY),
    },
    chase: {
      baseFormUrl: str(process.env.VUE_APP_CHASE_BASE_URL),
      jsLibraryUrl: str(process.env.VUE_APP_CHASE_JS_LIBRARY),
    },
    chaseuk: {
      baseFormUrl: str(process.env.VUE_APP_CHASE_UK_BASE_URL),
      redirectUrl: str(process.env.VUE_APP_CHASE_UK_REDIRECT_URL),
    },
    ucom: {
      jsLibraryUrl: str(process.env.VUE_APP_UCOM_JS_LIBRARY),
      isDebugConfiguration: bool(process.env.VUE_APP_UCOM_DEBUG_CONFIGURATION),
    },
    seon: {
      jsCdnHost: str(process.env.VUE_APP_SEON_CDN_HOST),
    },
    pepper: {
      jsLibraryUrl: str(process.env.VUE_APP_AMELIA_PEPPER_JS_LIBRARY),
      cssLibraryUrl: str(process.env.VUE_APP_AMELIA_PEPPER_CSS_LIBRARY),
    },
    applePay: {
      merchantIdUcom: str(process.env.VUE_APP_APPLE_PAY_MERCHANT_ID_UCOM),
      merchantIdChaseCanada: str(process.env.VUE_APP_APPLE_PAY_MERCHANT_ID_CHASE_CANADA),
    },
    googlePay: {
      merchantGateway: str(process.env.VUE_APP_GOOGLE_PAY_MERCHANT_GATEWAY),
      merchantGatewayIdUcom: str(process.env.VUE_APP_GOOGLE_PAY_MERCHANT_GATEWAY_ID_UCOM),
      merchantGatewayCanada: str(process.env.VUE_APP_GOOGLE_PAY_MERCHANT_GATEWAY_CANADA),
      merchantGatewayIdChaseCanada: str(process.env.VUE_APP_GOOGLE_PAY_MERCHANT_GATEWAY_ID_CHASE_CANADA),
      merchantId: str(process.env.VUE_APP_GOOGLE_PAY_MERCHANT_ID),
      environment: str(process.env.VUE_APP_GOOGLE_PAY_ENVIRONMENT),
    },
    idMe: {
      clientId: str(process.env.VUE_APP_ID_ME_CLIENT_ID),
      redirectUrl: str(process.env.VUE_APP_ID_ME_REDIRECT_URL),
      widgetScriptUrl: str(process.env.VUE_APP_ID_ME_WIDGET_SCRIPT_URL),
    },
    services: {
      gatewayUrl: str(process.env.VUE_APP_SERVICES_GATEWAY_URL),
      gatewaySubscriptionKey: str(process.env.VUE_APP_SERVICES_GATEWAY_SUBSCRIPTION_KEY),
      gatewayUrlUk: str(process.env.VUE_APP_SERVICES_GATEWAY_URL_UK),
      gatewaySubscriptionKeyUk: str(process.env.VUE_APP_SERVICES_GATEWAY_SUBSCRIPTION_KEY_UK),
      channel: str(process.env.VUE_APP_SERVICES_CHANNEL),
      refreshPointsThrottleTimeInMinutes: num(process.env.VUE_APP_SERVICES_REFRESH_POINTS_THROTTLE_TIME_IN_MINUTES),
    },
    cms: {
      baseUrl: cmsBaseUrl,
      baseUrlCanada: cmsBaseUrlCanada,
      baseUrlUk: cmsBaseUrlUk,
      // Product requested we remove the distinction between auth and guest for the hero banner. Changing it here so we can revert on request.
      // If the revert hasnt happened in a few months we should clean it up properly. Also see cms store.
      // promoBannerTopAuthenticatedDesktop: getPromoBanner(cmsBaseUrl, window._cmgPromoTopAuthenticatedDesktop),
      // promoBannerTopAuthenticatedMobile: getPromoBanner(cmsBaseUrl, window._cmgPromoTopAuthenticatedMobile),
      // promoBannerTopAuthenticatedDesktopCanada: getPromoBanner(cmsBaseUrl, window._cmgPromoTopAuthenticatedDesktopCanada),
      // promoBannerTopAuthenticatedMobileCanada: getPromoBanner(cmsBaseUrl, window._cmgPromoTopAuthenticatedMobileCanada),
      promoBannerTopAuthenticatedDesktop: getPromoBanner(cmsBaseUrl, isLocal ? indexedCmsVars[AEMVariables.promoBannerTopAuthenticatedDesktop] as AemPromoBanner : window[AEMVariables.promoBannerTopAuthenticatedDesktop]),
      promoBannerTopAuthenticatedMobile: getPromoBanner(cmsBaseUrl, isLocal ? indexedCmsVars[AEMVariables.promoBannerTopAuthenticatedMobile] as AemPromoBanner : window[AEMVariables.promoBannerTopAuthenticatedMobile]),
      promoBannerTopGuestDesktop: getPromoBanner(cmsBaseUrl, isLocal ? indexedCmsVars[AEMVariables.promoBannerTopGuestDesktop] as AemPromoBanner : window[AEMVariables.promoBannerTopGuestDesktop]),
      promoBannerTopGuestMobile: getPromoBanner(cmsBaseUrl, isLocal ? indexedCmsVars[AEMVariables.promoBannerTopGuestMobile] as AemPromoBanner : window[AEMVariables.promoBannerTopGuestMobile]),
      promoBannerTopAuthenticatedDesktopCanada: getPromoBanner(cmsBaseUrl, isLocal ? indexedCmsVars[AEMVariables.promoBannerTopAuthenticatedDesktopCanada] as AemPromoBanner : window[AEMVariables.promoBannerTopAuthenticatedDesktopCanada]),
      promoBannerTopAuthenticatedMobileCanada: getPromoBanner(cmsBaseUrl, isLocal ? indexedCmsVars[AEMVariables.promoBannerTopAuthenticatedMobileCanada] as AemPromoBanner : window[AEMVariables.promoBannerTopAuthenticatedMobileCanada]),
      promoBannerTopGuestDesktopCanada: getPromoBanner(cmsBaseUrl, isLocal ? indexedCmsVars[AEMVariables.promoBannerTopGuestDesktopCanada] as AemPromoBanner : window[AEMVariables.promoBannerTopGuestDesktopCanada]),
      promoBannerTopGuestMobileCanada: getPromoBanner(cmsBaseUrl, isLocal ? indexedCmsVars[AEMVariables.promoBannerTopGuestMobileCanada] as AemPromoBanner : window[AEMVariables.promoBannerTopGuestMobileCanada]),
      promoBannerBottom: getPromoBanner(cmsBaseUrl, isLocal ? indexedCmsVars[AEMVariables.promoBannerBottom] as AemPromoBanner : window[AEMVariables.promoBannerBottom]),
      promoBannerBottomCanada: getPromoBanner(cmsBaseUrl, isLocal ? indexedCmsVars[AEMVariables.promoBannerBottomCanada] as AemPromoBanner : window[AEMVariables.promoBannerBottomCanada]),
      promoBannerRewardsGuest: getPromoBanner(cmsBaseUrl, isLocal ? indexedCmsVars[AEMVariables.promoBannerRewardsGuest] as AemPromoBanner : window[AEMVariables.promoBannerRewardsGuest]),
      promoBannerRewardsAuthenticatedNotEnrolled: getPromoBanner(cmsBaseUrl, isLocal ? indexedCmsVars[AEMVariables.promoBannerRewardsAuthenticatedNotEnrolled] as AemPromoBanner : window[AEMVariables.promoBannerRewardsAuthenticatedNotEnrolled]),
      headerLinks: getHeaderLinks(cateringUrl),
      largeOrderPromo: getLargeOrderPromo(cmsBaseUrl, isLocal ? indexedCmsVars[AEMVariables.largeOrderPromo] as AemLargeOrderPromo : window[AEMVariables.largeOrderPromo]),
      guacMode: getGuacMode(isLocal ? indexedCmsVars[AEMVariables.guacMode] as AemGuacMode : window[AEMVariables.guacMode]),
      groupOrderCard: getLargeOrderCard(cmsBaseUrl, isLocal ? indexedCmsVars[AEMVariables.groupOrderCard] as AemLargeOrderCard : window[AEMVariables.groupOrderCard]),
      cateringCard: getLargeOrderCard(cmsBaseUrl, isLocal ? indexedCmsVars[AEMVariables.cateringCard] as AemLargeOrderCard : window[AEMVariables.cateringCard]),
      cateringCardCanada: getLargeOrderCard(cmsBaseUrl, isLocal ? indexedCmsVars[AEMVariables.cateringCardCanada] as AemLargeOrderCard : window[AEMVariables.cateringCardCanada]),
      homePageRewardsBanner: getRewardsBanner(cmsBaseUrl, isLocal ? indexedCmsVars[AEMVariables.homePageRewardsBanner] as AemRewardsBanner : window[AEMVariables.homePageRewardsBanner]),
      homePagePromoBannerCanada: getRewardsBanner(cmsBaseUrl, isLocal ? indexedCmsVars[AEMVariables.homePagePromoBannerCanada] as AemRewardsBanner : window[AEMVariables.homePagePromoBannerCanada]),
      rewardsPageGuacModeRewardsBanner: getRewardsBanner(cmsBaseUrl, isLocal ? indexedCmsVars[AEMVariables.rewardsPageGuacModeRewardsBanner] as AemRewardsBanner : window[AEMVariables.rewardsPageGuacModeRewardsBanner]),
      rewardsPageGuestUnenrolledRewardsBanner: getRewardsBanner(cmsBaseUrl, isLocal ? indexedCmsVars[AEMVariables.rewardsPageGuestUnenrolledRewardsBanner] as AemRewardsBanner : window[AEMVariables.rewardsPageGuestUnenrolledRewardsBanner]),
      systemFlags: getSystemFlags(isLocal ? indexedCmsVars[AEMVariables.systemFlags] as AemJSON : window[AEMVariables.systemFlags]),
      featuredPCE: getFeaturedPCE(isLocal ? indexedCmsVars[AEMVariables.featuredPCE] as AemFeaturedPCE : window[AEMVariables.featuredPCE]),
      metadata: getMetadata(isLocal ? indexedCmsVars[AEMVariables.metadata] as AemMetadata : window[AEMVariables.metadata]),
      titleAndDescription: getOrderWebTitleAndDescription(isLocal ? indexedCmsVars[AEMVariables.titleAndDescription] as AemMetadata : window[AEMVariables.titleAndDescription]),
      fullNutritionURL: getNutritionPath(isCanada ? (isLocal ? indexedCmsVars[AEMVariables.fullNutritionURLCanada] as AemNutritionPath : window[AEMVariables.fullNutritionURLCanada]) : (isLocal ? indexedCmsVars[AEMVariables.fullNutritionURL] as AemNutritionPath : window[AEMVariables.fullNutritionURL])),
      orderConfirmationCreateAccountExperience: getOrderConfirmationGuest(cmsBaseUrl, isLocal ? indexedCmsVars[AEMVariables.promoBannerRewardsAuthenticatedNotEnrolled] as AEMGuestOrderCreateAccountFragment : window[AEMVariables.orderConfirmationCreateAccountExperience])
    },
    urls: {
      buyGiftCards: str(process.env.VUE_APP_URL_BUY_GIFT_CARDS),
      support: isCanada ? str(process.env.VUE_APP_URL_SUPPORT_CANADA) : isUK ? str(process.env.VUE_APP_URL_SUPPORT_UK) : str(process.env.VUE_APP_URL_SUPPORT),
      catering: cateringUrl,
      rewardsTerms: str(process.env.VUE_APP_URL_REWARDS_TERMS),
      faq: str(process.env.VUE_APP_URL_FAQ),
      sessionFrameUrl: str(process.env.VUE_APP_SESSION_FRAME_URL),
      realFoodprint: str(process.env.VUE_APP_REAL_FOODPRINT_URL),
      howGood: str(process.env.VUE_APP_HOW_GOOD_URL),
      rewardsPath: str(process.env.VUE_APP_REWARDS_PATH),
      offersPath: str(process.env.VUE_APP_OFFERS_PATH),
      twitterAchievementBaseUrl: str(process.env.VUE_APP_TWITTER_ACHIEVEMENT_BASE_URL),
      allergenStatementUrl: str(process.env.VUE_APP_ALLERGEN_STATEMENT_URL),
    },
    logging: {
      level: (LogLevel[str(process.env.VUE_APP_LOGGING_LEVEL) as any] as any) as LogLevel,
      shouldVerifyFields: isLocal,
      maxFieldsLength: num(process.env.VUE_APP_LOGGING_MAX_FIELDS_LENGTH),
    },
    google: {
      mapsUrl: str(process.env.VUE_APP_GOOGLE_MAPS_URL),
      mapsApiKey: str(process.env.VUE_APP_GOOGLE_MAPS_API_KEY || process.env.VUE_APP_GOOGLE_MAPS_AUTH),
      mapsAuth: str(process.env.VUE_APP_GOOGLE_MAPS_AUTH),
      showRestaurantsWithNoAddress: bool(process.env.VUE_APP_SHOW_RESTAURANTS_WITH_NO_ADDRESS),
    },
    build: str(process.env.VUE_APP_BUILD),
    isStubPayment: bool(process.env.VUE_APP_IS_STUB_PAYMENT),
    stubPaymentInformation: {
      cardHolderName: str(process.env.VUE_APP_STUB_PAYMENT_CARD_HOLDER_NAME),
      chipotleWalletId: num(process.env.VUE_APP_STUB_PAYMENT_CHIPOTLE_WALLET_ID),
      creditCardExpiration: str(process.env.VUE_APP_STUB_PAYMENT_CREDIT_CARD_EXPIRATION),
      creditCardSingleUseToken: str(process.env.VUE_APP_STUB_PAYMENT_CREDIT_CARD_SINGLE_USE_TOKEN),
      creditCardType: str(process.env.VUE_APP_STUB_PAYMENT_CREDIT_CARD_TYPE),
      creditCardZipCode: str(process.env.VUE_APP_STUB_PAYMENT_CREDIT_CARD_ZIP_CODE),
      lastFourAccountNumbers: str(process.env.VUE_APP_STUB_PAYMENT_LAST_FOUR_ACCOUNT_NUMBERS),
      paymentProviderId: str(process.env.VUE_APP_STUB_PAYMENT_PAYMENT_PROVIDER_ID),
      paymentProviderId_CA: str(process.env.VUE_APP_STUB_PAYMENT_PAYMENT_PROVIDER_ID_CA),
      paymentType: str(process.env.VUE_APP_STUB_PAYMENT_PAYMENT_TYPE)
    },
    optinProgramLaunchDate: str(process.env.VUE_APP_OPTIN_PROGRAM_LAUNCH_DATE),
    split: {
      authorizationKey: str(process.env.VUE_APP_SPLIT_AUTHORIZATION_KEY),
    }
  };
}

function str(val: any): string {
  return val as string;
}

function bool(val: any): boolean {
  return (val && val.toLowerCase && val.toLowerCase() === 'true') || false;
}

function num(val: any): number | undefined {
  if (val === undefined) {
    return;
  }

  return parseFloat(val);
}

